import { render, staticRenderFns } from "./certificateSearch_list.vue?vue&type=template&id=2981426c&scoped=true"
import script from "./certificateSearch_list.vue?vue&type=script&lang=js"
export * from "./certificateSearch_list.vue?vue&type=script&lang=js"
import style0 from "./certificateSearch_list.vue?vue&type=style&index=0&id=2981426c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2981426c",
  null
  
)

export default component.exports